import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'base-rating',
  templateUrl: './base-rating.component.html',
})
export class BaseRatingComponent {
  @Input() currentRate: number | undefined;
  @Input() reviewCount: number | undefined = 0;
  @Input() formControl: UntypedFormControl;
  @Input() hideCount = false;
  @Input() isInvalid = false;
  @Input() errorMessage: string | null = null;
  @Input() starIconClasses = '';
}
